import styles from './ClientContact.module.css'
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import {useNavigate} from "react-router-dom";

interface ClientInfoInt
{
    phone: string
    eMail:string
    login:string
    user:string
}
export default function ClientContact()
{
    const errorLineRef = useRef<ErrorLineItemRef>(null)
    const navigate = useNavigate();

    const contactInfoData = useRef()
    const [ldrContactInfo,rsContactInfo,exContactInfo] = useApiQuery("/sell/sim/client/contact","get",contactInfoData);
    const [clientInfo, setClientInfo] = useState<ClientInfoInt>({
        phone: "",
        eMail: "",
        login:"",
        user:""
    })

    const [isCorrect, setIsCorrect] = useState(true)


    const updateInfoData = useRef<ClientInfoInt>()
    const [ldrUpdateInfoData,rsUpdateInfoData,exUpdateInfoData] = useApiQuery("/sell/sim/client/contact/update","post",updateInfoData);


    useEffect(()=>{
        loadInfo()
    },[contactInfoData])

    const loadInfo = () =>{
        exContactInfo().then((e)=>{
            if(e?.success)
            {
                const payload = e?.payload
                console.log(e?.payload)
                const phone = payload?.userDefineOne?.phone ? payload?.userDefineOne?.phone : ""
                const mail = payload?.userDefineOne?.eMail ? payload?.userDefineOne?.eMail : ""
                const login = payload?.alias ? payload?.alias : payload?.user ? payload?.user : ""
                const user = payload?.user ? payload?.user : "серия и номер паспорта"
                setClientInfo({
                    phone: phone,
                    eMail:mail,
                    login:login,
                    user:user
                })

                return
            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,2000)
        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,2000)
        })
    }
    const normCtn = (e:string) => {
        const t = e.toString()
        const mh = t.match(/[0-9]{10}$/ui)
        if(mh) return "+7" + mh[0]
        return t

    }


    const handleUpdate = () =>{
        console.log("test", clientInfo)
        if(clientInfo.login.length && !clientInfo.login.match(/^[a-z0-9]+[a-z0-9-_]+$/ui))
        {
            if(errorLineRef?.current)errorLineRef?.current?.show("Не корректный логин",true,2000)
            return
        }
        if(clientInfo.phone.length && !clientInfo.phone.match(/(((\+7)|(8)|(^))9[0-9]{9}$)/ui))
        {
            if(errorLineRef?.current)errorLineRef?.current?.show("Не корректный телефон",true,2000)
            return
        }
        if(clientInfo.eMail.length && !clientInfo.eMail.match(/(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$)/ui))
        {
            console.log("test 2")
            if(errorLineRef?.current)errorLineRef?.current?.show("Не корректный почтовый ящик",true,2000)
            return
        }
        updateInfoData.current = {
            phone: clientInfo?.phone,
            eMail: clientInfo?.eMail,
            login:clientInfo?.login,
            user: clientInfo?.user
        }
        exUpdateInfoData().then((e)=>{
            if(e?.success)
            {
                if(errorLineRef?.current)errorLineRef?.current?.show("Данные обновлены",false,2000)

                setTimeout(()=>navigate('/lk/client/order/list'),2000)
                return
            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,2000)

        })
    }

    return(
        <div className={styles.mainCont}>
            <div className={styles.title}>Ваши контактные данные, по которым мы можем с Вами связаться,
                почта также используется для восстановления пароля. Вы можете задать альтернативный логин, который будет использоваться наравне с действующим [ {clientInfo?.user} ]</div>
            <div className={styles.iCont}>
                <InputItem
                    title={"Логин"}
                    val={clientInfo.login}
                    placeHolder={"Логин"}
                    info={"Логин в личный кабинет ( например ivan33)"}
                    mode={"ei"}
                    regExp={/(^[a-z0-9]+[a-z0-9-_]{4,20}$)/ui}
                    onChange={(e)=> setClientInfo({...clientInfo,login: e})}
                    onBlur={(e)=>{
                        if(! e?.length)
                        {
                            setClientInfo({...clientInfo,login: ""})
                            return

                        }
                        setClientInfo({...clientInfo,login: e.trim()})
                    }}


                ></InputItem>
                <InputItem
                    title={"Телефон"}
                    val={clientInfo.phone}
                    placeHolder={"XXXXXXXXXX"}
                    info={"Номер телефона"}
                    mode={"ei"}
                    type={"number"}
                    regExp={/(((\+7)|(8)|(^))9[0-9]{9}$)|(^$)/ui}
                    onPreProcess={(e)=>normCtn(e)}
                    onChange={(e)=> setClientInfo({...clientInfo,phone: e})}

                    onCorrect={(e)=>{
                        if(e?.length)setClientInfo({...clientInfo,phone: normCtn(e)})

                    }}
                    onBlur={(e)=>{
                        if(! e?.length)
                        {
                            setClientInfo({...clientInfo,phone: ""})
                            return

                        }
                        setClientInfo({...clientInfo,phone: e.trim()})
                    }}


                ></InputItem>

                <InputItem
                    title={"e-Mail"}
                    val={clientInfo.eMail}
                    placeHolder={"eMail"}
                    info={"Почтовый ящик"}
                    mode={"ei"}
                    regExp={/(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$)|(^$)/ui}
                    onPreProcess={(e)=>normCtn(e)}
                    onCorrect={(e)=>{
                        if(e?.length)setClientInfo({...clientInfo,eMail: e.trim()})

                    }}
                    onChange={(e)=> setClientInfo({...clientInfo,eMail: e})}
                    onBlur={(e)=>{
                        if(! e?.length)
                        {
                            setClientInfo({...clientInfo,eMail: ""})
                            return

                        }
                        setClientInfo({...clientInfo,eMail: e.trim()})
                    }}


                ></InputItem>


            </div>
            <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>
            <div className={styles.btnCont}>
                <button type="button" className="btn btn-secondary "
                    onClick={()=>handleUpdate()}
                >Обновить</button>
                <WaitLoader loading={ldrUpdateInfoData} api={rsUpdateInfoData} onlyLoading={true}>

                </WaitLoader>


            </div>


        </div>
    )
}